export default {
  maskMoney: {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    precision: 2,
    masked: false
  }
}


// WEBPACK FOOTER //
// ./src/helpers/mask.js